
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import Header from './components/feature/Header';
import Footer from './components/feature/Footer';
import NutrareHeader from './components/feature/NutrareHeader';
import NutrareFooter from './components/feature/NutrareFooter';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

function AppContent() {
  const location = useLocation();
  const isEnjoyPage = location.pathname.startsWith('/enjoy');
  const isNutrarePage = location.pathname.startsWith('/nutrare');

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col">
      {!isEnjoyPage && !isNutrarePage && <Header />}
      {isNutrarePage && <NutrareHeader />}
      <main className="flex-1">
        <AppRoutes />
      </main>
      {!isEnjoyPage && !isNutrarePage && <Footer />}
      {isNutrarePage && <NutrareFooter />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
